import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询备案批次列表
export function queryOpenPriceBatch(data) {
  return request({
    url: URL.price.openPrice.queryOpenPriceBatch,
    method: 'post',
    data
  })
}
// 获取备案批次详情
export function detailOpenPriceBatch(data) {
  return request({
    url: URL.price.openPrice.detailOpenPriceBatch,
    method: 'post',
    data
  })
}
// 保存备案批次
export function saveOpenPriceBatch(data) {
  return request({
    url: URL.price.openPrice.saveOpenPriceBatch,
    method: 'post',
    data
  })
}
// 复制备案批次
export function copyOpenPriceBatch(data) {
  return request({
    url: URL.price.openPrice.copyOpenPriceBatch,
    method: 'post',
    data
  })
}
// 删除备案批次
export function deleteOpenPriceBatch(data) {
  return request({
    url: URL.price.openPrice.deleteOpenPriceBatch,
    method: 'post',
    data
  })
}
// 启动/暂停RPA
export function setRpaStatus(data) {
  return request({
    url: URL.price.openPrice.setRpaStatus,
    method: 'post',
    data
  })
}
// 获取操作日志列表
export function queryOplogList(data) {
  return request({
    url: URL.price.openPrice.queryOplogList,
    method: 'post',
    data
  })
}
// 查询最终运价列表
export function queryFinalList(data) {
  return request({
    url: URL.price.openPrice.queryFinalList,
    method: 'post',
    data
  })
}
// 获取航交所数据映射
export function getDataMapping(data) {
  return request({
    url: URL.price.openPrice.getDataMapping,
    method: 'post',
    data
  })
}
// 手动导出文件
export function manuallyExportFileExcel(data) {
  return request({
    url: URL.price.openPrice.manuallyExportFileExcel,
    method: 'post',
    data
  })
}
// 查询分公司RPA设置
export function queryRpaSetting(data) {
  return request({
    url: URL.price.openPrice.queryRpaSetting,
    method: 'post',
    data
  })
}
// 获取近6个月业务的港口
export function queryPast6MonthsPortList(data) {
  return request({
    url: URL.price.openPrice.queryPast6MonthsPortList,
    method: 'post',
    data
  })
}
// 获取近1个月开船的运价
export function queryPast1MonthsPriceList(data) {
  return request({
    url: URL.price.openPrice.queryPast1MonthsPriceList,
    method: 'post',
    data
  })
}
